module.exports = __webpack_public_path__ + "img/no.f1f421a.svg";